import { render, staticRenderFns } from "./InvoiceOutboundTable.vue?vue&type=template&id=f9f68ca8&"
import script from "./InvoiceOutboundTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOutboundTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
